function strCamelToSnakeCase(str) {
  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

function objectKeysCamelToSnakeCase(obj) {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [strCamelToSnakeCase(k), v]));
}

export { strCamelToSnakeCase, objectKeysCamelToSnakeCase }
